export default __webpack_public_path__ + "static/media/xtend.ffee453a.svg";